import { createApi } from '@reduxjs/toolkit/query/react';
import { customBaseQuery } from '../../utils/customBaseQuery';

export const wishlistApi = createApi({
	reducerPath: 'wishlistApi',
	baseQuery: customBaseQuery,
	refetchOnFocus: true,
	refetchOnReconnect: true,
	endpoints: (builder) => ({

		// POST — Добавить item в wishlist
		addWishlist: builder.mutation({
			query: ({ data, schema }) => ({
				url: '/add',
				method: 'POST',
				body: data,
				schema,
				prefix: 'wishlist',
			}),
		}),

		// GET — Получить wishlist по userId
		getUserWishlist: builder.query({
			query: ({ userId, schema }) => ({
				url: `/${userId}`,
				method: 'GET',
				schema,
				prefix: 'wishlist',
			}),
		}),

		// POST — Удалить item из wishlist
		deleteWishlistItem: builder.mutation({
			query: ({ data, schema }) => ({
				url: '/remove',
				method: 'POST',
				body: data,
				schema,
				prefix: 'wishlist',
			}),
		}),

	}),
});

export const {
	useAddWishlistMutation,
	useGetUserWishlistQuery,
	useDeleteWishlistItemMutation,
} = wishlistApi;
